<div class="search-filter-container" #searchFilterContainer>

  <div class="search-container" [class.fixed]="isOpened" [class.show]="isOpened || !displayInMobile">
    <div class="field-label" fiTranslation="REQUEST_OVERVIEW_SEARCH_LABEL"></div>
    <form class="search-field-inner" (submit)="onSearchSubmit($event)">
      <img src="assets/icons/search-dark.svg" alt="search" class="search-icon" #search
        [isTitle]="true" fiTranslation="ALT_TEXT_REQUEST_OVERVIEW_FILTER"
        matTooltip="{{search.dataset.matTooltip}}"
        matTooltipPosition="below" matTooltipClass='tooltip-style'>

      <input #searchInput type="search" class="search-input" fiTranslation="SEARCH_PLACEHOLDER"
        [isPLaceHolder]="true" value="{{searchedString}}"
        (pointerdown)="onMobileSearchPointerDown($event)"
        (click)="onClickSearch()">

      @if (searchInput.value) {
        <div class="clear-input" (click)="clearInputText()">
          <mat-icon class="clear-icon">close</mat-icon>
        </div>
      }
    </form>

  </div>
</div>
